import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { EmbodimentRulesModel } from '../embodiment-rules-model';
import type { EmbodimentRule } from '../../types';

@injectable()
export class EmbodimentRulesModelImpl extends AbstractModel<EmbodimentRule[]> implements EmbodimentRulesModel {
    protected _modelData: EmbodimentRule[] = [];
}
